<template>
  <div class="container">
    <!-- Sidebar: User List -->
    <div class="sidebar">
      <h2>Utilizadores</h2>
      <ul>
        <li
          v-for="user in users"
          :key="user.id"
          :class="{ selected: selectedUser && selectedUser.id === user.id }"
          @click="selectUser(user)"
        >
          {{ user.username }}
        </li>
      </ul>
    </div>

    <!-- Main Content: User Details -->
    <div class="content">
      <div v-if="selectedUser">
        <!-- Top Section: User Info Cards -->
        <div class="info-cards">
          <div class="card">
            <h3>Dívida Total</h3>
            <p class="owed">AED {{ selectedUser.amount_owed }}</p>
            <p class="owed">EUR {{ selectedUser.amount_owed_eur }}</p>
          </div>
          <div class="card">
            <h3>Quantia Paga</h3>
            <p class="paid">AED {{ selectedUser.amount_paid }}</p>
            <p class="paid">EUR {{ selectedUser.amount_paid_eur }}</p>
          </div>
          <div class="card">
            <h3>Por Pagar</h3>
            <p class="total">AED {{ selectedUser.balance }}</p>
            <p class="total">EUR {{ selectedUser.balance_eur }}</p>
          </div>
        </div>

        <!-- Bottom Section: Payment List -->
        <div class="payments">
          <h3>
            Pagamentos
            <button
              class="payment-btn"
              @click="insert_payment"
              :disabled="selectedUser.user_id !== loggedUserId"
            >
              Inserir Pagamento
            </button>
          </h3>

          <ul>
            <li
              v-for="payment in selectedUser.payments"
              :key="payment.id"
              :class="{
                validated: payment.validated,
                'not-validated': !payment.validated,
              }"
            >
              <span>{{ payment.created_at.split('T')[0] }}:</span>
              <span class="amount">
                AED{{ payment.amount }}/€{{ payment.amount_eur }}</span
              >
              <span class="status">
                - Validado: {{ payment.validated ? 'Sim' : 'Não' }}</span
              >
              <button
                @click="payment_validation(payment)"
                class="validate-button"
                :disabled="loggedUserId !== 9"
              >
                Validar
              </button>
            </li>
          </ul>
        </div>

        <div
          class="shipments"
          v-if="
            selectedUser.shippedProducts && selectedUser.shippedProducts.length
          "
        >
          <!-- Title always outside the scrollable box -->
          <h3>Produtos Enviados</h3>

          <!-- Only this wrapper scrolls -->
          <div class="shipments-body">
            <table class="shipments-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>ID</th>
                  <th class="col-name">Nome</th>
                  <th>Status</th>
                  <th>Quantidade Enviada</th>
                  <th>Preço Final</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx) in selectedUser.shippedProducts"
                  :key="idx"
                >
                  <td>{{ item.created_at.split('T')[0] }}</td>
                  <td>{{ item.id }}</td>
                  <td class="col-name">{{ item.client_product.name }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.qty_sent }}</td>
                  <td>AED {{ item.price_final }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-else class="empty-state">
        Selecione um utilizador para ver detalhes
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js';
export default {
  data() {
    return {
      users: [],
      selectedUser: null,
    };
  },
  methods: {
    async insert_payment() {
      this.$swal({
        title: 'Inserir Pagamento',
        html: '<input id="amount" class="swal2-input" placeholder="AED" style="max-width:200px; width:100%; box-sizing:border-box;"> ',
        focusConfirm: false,
        preConfirm: () => {
          const amount = document.getElementById('amount').value;
          return { amount };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('Amount:', result.value.amount);
          const payload = {
            amount: result.value.amount,
            // user_id: 26,
            user_id: this.selectedUser.user_id,
          };
          this.$store
            .dispatch('insertPaymentFinTracker', payload)
            .then(() => {
              this.loadData();
              console.log('Payment inserted successfully');
            })
            .catch((error) => {
              console.error('Error inserting payment:', error);
            });
        }
      });
      // try {
      //   const payload = {
      //     user_id: user_id,
      //     amount: amount,
      //   };
      //   await this.$store.dispatch('insertPaymentFinTracker', payload);
      //   await this.loadData();
      //   console.log('Payment inserted successfully');
      // } catch (error) {
      //   console.error(error);
      // }
    },
    async payment_validation(payment) {
      payment.validated = true;
      try {
        const payload = {
          payment_id: payment.id,
        };
        await this.$store.dispatch('validatePayment', payload);
        await this.loadData();
        // Reassign selectedUser to the updated object from the users array
        const updatedUser = this.users.find(
          (user) => user.id === this.selectedUser.id
        );
        await this.selectUser(updatedUser);
        console.log('Payment validated successfully');
        console.log(this.users);
      } catch (error) {
        console.error(error);
      }
    },
    async loadData() {
      try {
        await this.$store.dispatch('getUsersFinTrack');
        this.users = this.getUsersFinTrack;
        console.log('users: ', this.users);
      } catch (error) {
        console.error(error);
      }
    },
    async selectUser(user) {
      this.selectedUser = user;
      try {
        console.log(user.user_id);
        // fetch payments
        const payload = { user_id: user.id };
        await this.$store.dispatch('getFinTrackPayments', payload);
        console.log('PAYMENTS', this.getPayments);
        this.$set(this.selectedUser, 'payments', this.getPayments);

        // fetch shipped products
        await this.$store.dispatch('getRequestsClientAdmin', {
          status: 'sent',
          sku: '',
          sort_by: 'id',
          sort_dir: 'desc',
        });
        this.$set(this.selectedUser, 'shippedProducts', this.getRequestsClient);
        console.log(this.selectedUser.payments);
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    ...mapGetters([
      'getUsersFinTrack',
      'getPayments',
      'validatePayment',
      'getRequestsClient',
    ]),
    loggedUserId() {
      try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        return u.user_id;
      } catch {
        return null;
      }
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style>
.shipments-body {
  max-height: 450px;
  overflow-y: auto;
}

.shipments-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* enforce fixed column widths */
}

/* wrap text in all cells so long names break */
.shipments-table td,
.shipments-table th {
  padding: 8px;
  border: 1px solid #ddd;
  white-space: normal; /* allow wrapping */
  word-wrap: break-word; /* break long words */
  text-align: left;
}

/* fixed width for the “Produto” column */

.shipments-table th.col-name,
.shipments-table td.col-name {
  width: 200px; /* adjust as needed */
}

.shipments-table th {
  background-color: #f2f2f2;
  position: sticky;
  top: 0;
  z-index: 1;
}

.shipments-table tr:nth-child(even) {
  background-color: #fafafa;
}

.shipments-table tr:hover {
  background-color: #f5f5f5;
}

.container {
  display: flex;
  max-width: 1200px; /* or whatever maximum width you’d like */
  margin: 0 auto; /* horizontal centering */
  height: 100vh;
}
/* .sidebar {
  width: 25%;
  background: #f0f0f0;
  padding: 20px;
  border-right: 1px solid #ccc;
} */
.sidebar {
  flex: 0 0 15%; /* was 25%—now only 15% of the width */
  max-width: 15%;
}
.sidebar ul {
  list-style: none;
  padding: 0;
}
.sidebar li {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
}
.sidebar li:hover,
.sidebar .selected {
  background: #ccc;
}
/* .content {
  flex: 1;
  padding: 20px;
} */

.content {
  flex: 1; /* takes the remaining 85% */
  padding: 20px;
}
.info-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.card {
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  flex: 1;
  margin: 0 10px;
}
.owed {
  color: red;
  font-weight: bold;
}
.paid {
  color: green;
  font-weight: bold;
}
.total {
  color: blue;
  font-weight: bold;
}
.payments {
  background: white;
  padding: 20px;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
}
.payments ul {
  list-style: none;
  padding: 0;
}
.payments li {
  padding: 5px 0;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.payments li.validated {
  background: #d4edda;
}
.payments li.not-validated {
  background: #f8d7da;
}
.payment-btn {
  font-size: 0.75em; /* smaller text */
  padding: 0.25em 0.5em; /* tighter padding */
  line-height: 1; /* collapse height */
  margin-left: 0.5em; /* space from the heading text */
  vertical-align: middle;
  border: none;
  background: #ff9393;
  color: rgb(0, 0, 0);
}
.payment-btn:hover {
  background: #b16969;
}

.payment-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.validate-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.validate-button {
  margin-left: 10px;
  padding: 5px 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.validate-button:hover {
  background: #0056b3;
}
.empty-state {
  text-align: center;
  color: gray;
}
</style>
